export default {
  'ec.guide.zxbl':'Apply online',
  'ec.guide.zxbl.zbzc':'Not at this time',
  'ec.guide.sc':'Collection',
}